import * as React from 'react';
import { Context } from '@grandvisionhq/carts-v2';
import { useSelector, useDispatch } from '@grandvisionhq/state';
import { selectPickupPoint, selectStore, selectShippingMethod } from '../../StepShipping/actions.js';
import { getSelectedShippingMethod, getSelectedStore, getSelectedPickupPoint } from '../../StepShipping/selectors.js';
import '@swc/helpers';
import 'lodash/isEmpty';
import '@grandvisionhq/utils';
import '../../mappers/errors-mapping.js';
import '../../utils/get-customer-details-payload.js';
import { isPickupPoint, isPickupStore } from '../../utils/shipping-method.js';
import 'history';
import '../../models/cart/cart-state.js';
import '../../models/checkout/checkout-step-error-type.js';
import '../../models/checkout-settings.js';
import '../../models/step-shipping/shipping-methods.js';
import '../../models/shared.js';
import '../../utils/has-cart-errors.js';

const useRestoreCartShippingMethod = ()=>{
    var ref2;
    const shippingMethod = useSelector(getSelectedShippingMethod);
    const { cart  } = Context.useCart();
    const dispatch = useDispatch();
    const selectedStore = useSelector(getSelectedStore);
    const selectedPickupPoint = useSelector(getSelectedPickupPoint);
    const restoreShippingMethod = React.useCallback(()=>{
        var ref;
        if ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) && isPickupPoint(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) && selectedPickupPoint) {
            dispatch(selectPickupPoint({
                pickupPoint: undefined
            }));
        }
        if ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) && isPickupStore(shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) && selectedStore) {
            dispatch(selectStore({
                store: undefined
            }));
        }
        if ((shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method) !== (cart === null || cart === void 0 ? void 0 : (ref = cart.shippingMethod) === null || ref === void 0 ? void 0 : ref.key)) {
            var ref1;
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: cart === null || cart === void 0 ? void 0 : (ref1 = cart.shippingMethod) === null || ref1 === void 0 ? void 0 : ref1.key,
                    isValid: true,
                    isTouched: true
                }
            }));
        } else {
            dispatch(selectShippingMethod({
                shippingMethod: {
                    method: undefined,
                    isValid: false,
                    isTouched: false
                }
            }));
        }
    }, [
        shippingMethod === null || shippingMethod === void 0 ? void 0 : shippingMethod.method,
        selectedPickupPoint,
        selectedStore,
        cart === null || cart === void 0 ? void 0 : (ref2 = cart.shippingMethod) === null || ref2 === void 0 ? void 0 : ref2.key,
        dispatch, 
    ]);
    return {
        restoreShippingMethod
    };
};

export { useRestoreCartShippingMethod };
//# sourceMappingURL=use-restore-cart-shipping-method.js.map
